<template>
    <div class="p-6 max-w-2xl mx-auto bg-white">
        <h1 class="text-2xl font-bold mb-6 text-red-600">Réservation de tickets</h1>

        <div v-for="(ticket, index) in tickets" :key="index"
            class="mb-6 border border-gray-200 rounded-lg shadow p-5 hover:shadow-lg transition cursor-pointer">
            <h2 class="font-semibold text-lg mb-4 text-gray-800">🎟️ Ticket {{ index + 1 }}</h2>

            <!-- Boissons -->
            <div class="mb-4">
                <label class="block mb-2 text-sm font-medium text-gray-700">Choisir les boissons</label>
                <select v-model="ticket.boisson" multiple
                    class="w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-red-500">
                    <option v-for="drink in boissonsDispo" :key="drink.id" :value="drink.id">
                        {{ drink.nom }}
                    </option>
                </select>
            </div>

            <!-- Nom du détenteur -->
            <div>
                <label class="block mb-2 text-sm font-medium text-gray-700">Nom du détenteur</label>
                <input v-model="ticket.nom" type="text" placeholder="Entrez un nom"
                    class="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500" />
            </div>
        </div>

        <!-- Bouton de validation -->
        <button @click="validerReservation"
            class="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition font-semibold">
            Valider la réservation
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // Ex. 3 tickets — tu peux générer dynamiquement selon besoin
            tickets: [
                { nom: '', boisson: [] },
                { nom: '', boisson: [] },
                { nom: '', boisson: [] },
            ],

            // Boissons disponibles (à remplacer par un appel API si nécessaire)
            boissonsDispo: [
                { id: 1, nom: 'Coca' },
                { id: 2, nom: 'Fanta' },
                { id: 3, nom: 'Bière' },
                { id: 4, nom: 'Jus d\'orange' },
            ]
        };
    },

    methods: {
        validerReservation() {
            // Nettoyage des données si besoin
            const reservation = this.tickets.map(ticket => ({
                nom: ticket.nom.trim(),
                boissons: ticket.boisson
            }));

            console.log("Réservation à envoyer :", reservation);

            // Exemple : envoi avec axios
            // axios.post('/api/reservation', { tickets: reservation }).then(...);
        }
    }
};
</script>

<style scoped>
/* Bonus animation hover si tu veux */
.hover\:shadow-lg:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}
</style>
